/* eslint-disable react/prop-types */
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import "./styles.css";
import Config from "../../../../../../config/config";
import { copyToClipboard } from "@phntms/react-share";
import { toast } from "react-toastify";

const ModalLinks = ({ isOpen, toggle, afiliado }) => {
  
  const handleCopiar = (link) => {
    copyToClipboard(link);
    toast.success("Link copiado!");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Link de Afiliado</ModalHeader>
      <ModalBody>
        <div style={{ textAlign: "center" }}>
          <div className="lista-links">
            <div className="link-item">
              <div>
                <p>Link</p>

                <a
                  href={`${Config.URL_AFILIADO}?id=${afiliado}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {`${Config.URL_AFILIADO}?id=${afiliado}`}
                </a>
              </div>
              <Button
                color="primary"
                size="sm"
                onClick={() =>
                  handleCopiar(`${Config.URL_AFILIADO}?id=${afiliado}`)
                }
              >
                Copiar link
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalLinks;
